<div class="container">
  <div class="loader" #loader></div>
  @if (announce) {
    <div class="show-for-sr" role="status" aria-live="polite" aria-atomic="true">{{announceText}}</div>
  }
  @if (text) {
    <div class="text"
      [style.color]="color | safeHtml: 'style'"
    #textElement aria-hidden="true">{{text}}</div>
  }
</div>